import { RowStack, Spacer } from '@inbox-demo-nx/ui';
import { ChannelBadge } from '@inbox-demo-nx/ui-badges';
import { useGetChannelTitle } from '@inbox-demo-nx/utils-chat-common';
import { Text, useDripsyTheme, useSx, View } from 'dripsy';
import { ReactNode, useMemo } from 'react';
import SendBird from 'sendbird';

import ChannelCover from './ChannelCover';
import ChannelSubtitle from './ChannelSubtitle';

export type ChannelHeaderTitleProps = {
  channel: SendBird.GroupChannel;
  renderSubtitle?: (props: { channel: SendBird.GroupChannel }) => ReactNode;
  renderBadge?: (props: { channel: SendBird.GroupChannel }) => ReactNode;
  renderAvatar?: (props: {
    channel: SendBird.GroupChannel;
    size: number;
  }) => ReactNode;
};

export function ChannelHeaderTitle({
  channel,
  renderSubtitle = ChannelSubtitle,
  renderBadge,
  renderAvatar = ChannelCover,
}: ChannelHeaderTitleProps) {
  const sx = useSx();
  const { theme } = useDripsyTheme();
  const getChannelTitle = useGetChannelTitle();

  const renderedBadge = useMemo(() => {
    const defaultRenderBadge: ChannelHeaderTitleProps['renderBadge'] = (
      props
    ) => (
      <ChannelBadge color={theme.colors.navigationHeaderTextColor} {...props} />
    );
    return (renderBadge || defaultRenderBadge)({ channel });
  }, [channel, renderBadge, theme.colors.navigationHeaderTextColor]);

  return (
    <RowStack style={sx({ justifyContent: 'flex-start' })}>
      {renderAvatar({ channel, size: 36 })}
      <Spacer size={8} />
      <View style={{ flex: 1, justifyContent: 'center' }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <>
            <Text
              sx={{
                fontSize: 'medium',
                fontWeight: '600',
                marginRight: 2,
                color: 'navigationHeaderTextColor',
              }}
              numberOfLines={1}
            >
              {getChannelTitle(channel)}
            </Text>
            {renderedBadge}
          </>
        </View>
        {renderSubtitle({ channel })}
      </View>
    </RowStack>
  );
}
